export default theme => ({
  gridContainer: {
    padding: theme.spacing.unit,
  },
});



// WEBPACK FOOTER //
// ./src/modules/requests/cards/CourseRequestsCard/styles.js